export default {
  "af-default": () => import("/opt/atlassian/pipelines/agent/build/layouts/af-default.vue").then(m => m.default || m),
  checkout: () => import("/opt/atlassian/pipelines/agent/build/layouts/checkout.vue").then(m => m.default || m),
  "default-catalog": () => import("/opt/atlassian/pipelines/agent/build/layouts/default-catalog.vue").then(m => m.default || m),
  default: () => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m),
  "home-layout": () => import("/opt/atlassian/pipelines/agent/build/layouts/homeLayout.vue").then(m => m.default || m)
}